(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/game-guide/assets/javascripts/article-page.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/game-guide/assets/javascripts/article-page.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const loadArticle = svs.content.simple_article.contentLoader.loadArticle;
const Loader = svs.components.ReactLoader.Loader;
const log = svs.core.log;
const logger = log.getLogger('component:load-article');
const Icon = svs.ui.ReactIcon;
const EmptyView = () => React.createElement("div", {
  className: "game-guide-oddset-empty align-center margin-top-4"
}, React.createElement(Icon, {
  color: "fc-oddset",
  icon: "rest",
  size: "900"
}), React.createElement("p", null, "Inneh\xE5llet kunde inte visas, prova igen"));
const ArticlePage = _ref => {
  let articleId = _ref.articleId;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    articleContent = _useState4[0],
    setArticleContent = _useState4[1];
  useEffect(() => {
    if (articleId) {
      setIsLoading(true);
      const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-lb');
      if (useLegacyJupiterApi) {
        const options = {
          url: new svs.content.shared.ContentUrlBuilder("/content/2/id/".concat(articleId)).build()
        };
        loadArticle(options, (err, article) => {
          if (err) {
            setArticleContent(null);
            logger.warn('Error retrieving spelguide', err);
          } else if (!err && !article) {
            setArticleContent(null);
            logger.warn('No spelguide found with provided id');
          } else {
            setArticleContent(article);
          }
          setIsLoading(false);
        });
        return;
      }
      const client = svs.content.shared.getCmsClient();
      client.v1.content.getById(articleId).then(article => {
        if (!article) {
          setArticleContent(null);
          logger.warn('No spelguide found with provided id (CMS API)');
        } else {
          setArticleContent(article);
        }
        setIsLoading(false);
      }).catch(err => {
        setArticleContent(null);
        logger.warn('Error retrieving spelguide (CMS API)', err);
        setIsLoading(false);
      });
    }
  }, [articleId]);
  if (isLoading) {
    return React.createElement(Loader, null);
  }
  if (!articleContent) {
    return React.createElement(EmptyView, null);
  }

  return React.createElement("div", {
    className: "oddset-game-guide-article f-content"
  }, React.createElement("h2", {
    dangerouslySetInnerHTML: {
      __html: articleContent.title
    }
  }), React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: articleContent.ingress
    }
  }), React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: articleContent.body
    }
  }));
};
setGlobal('svs.oddset_kambi.components.game_guide.ArticlePage', ArticlePage);

 })(window);